import * as __model from '../model';

export class DowloadBatch {
    mainPartnerKey?: string;
    buyerId?: number;

}